import { formatDate } from '@angular/common';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-show',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class ShowComponent implements OnInit, AfterViewInit {
  public showId: any;
  public competitions: any;
  public show: any;
  public day: any;
  public dayButtons: any;
  announcements: any;
  today: any;

  // People search properties
  public isEquestrianDigital: boolean = window.location.href.includes('equestrian.digital') || window.location.href.includes('localhost');
  public peopleSearchQuery: string = '';
  public peopleSearchResults: any[] = [];
  public showPeopleSearch: boolean = false;
  public isPeopleSearchLoading: boolean = false;

  constructor(private db: AngularFirestore, private route: ActivatedRoute) {
    this.showId = this.route.snapshot.paramMap.get('showId');
    this.competitions = [];
    this.day = '';
    this.dayButtons = '';
  }

  ngOnInit() {
    this.getShow();
    this.getCompetitions();
    this.today = Date.now();
    this.today = formatDate(this.today, 'yyyy-MM-dd', 'en-US');
    this.getAnnouncements();
  }

  ngAfterViewInit() {

  }

  // People search methods
  public async onPeopleSearch(event: any) {
    const query = event.target.value;
    this.peopleSearchQuery = query;
    
    if (query.length >= 2) {
      this.isPeopleSearchLoading = true;
      this.showPeopleSearch = true;
      
      try {
        //this.peopleSearchResults = await this.algolia.searchPeople(query, this.showId);
      } catch (error) {
        this.peopleSearchResults = [];
      } finally {
        this.isPeopleSearchLoading = false;
      }
    } else {
      this.showPeopleSearch = false;
      this.peopleSearchResults = [];
    }
  }

  public selectPerson(person: any) {
    this.showPeopleSearch = false;
    this.peopleSearchResults = [];
    this.peopleSearchQuery = '';
    
    // Navigate to person profile based on type
    if (person.type === 'rider') {
      window.location.href = `/rider-profile/${person.objectID}`;
    } else if (person.type === 'trainer') {
      // Navigate to trainer profile - you'll need to implement this route
      window.location.href = `/trainer-profile/${this.showId}/${person.objectID}`;
    }
  }

  public setDay(day) {
    this.day = day;
    // Deactivate buttons

    this.dayButtons = document.getElementsByClassName('dayButton');
    this.dayButtons.forEach(element => {
      element.classList.remove('active');
    });
    if (this.dayButtons.length > 0) {
      document.getElementById(day).classList.add('active');
    } else {
      this.getFilteredCompetitions();
    }


  }

  private getShow() {
    this.db.collection('concursos').doc(this.showId).valueChanges().subscribe(
      show => {
        this.show = show;
        //Convertir fechas en formato timestamp de firestore a objetos de fecha js
        this.show.inicio = this.show.inicio.toDate();
        this.show.fin = this.show.fin.toDate();
        console.log(this.show);
        // Checar si estamos en dia de concurso. Se compara el primer dia del arreglo y el ultimo con la fecha actual
        if (this.today >= this.show.dias[0] && this.today <= this.show.dias.at(-1)) {
          // En caso contrario vamos a seleccionar el dia de hoy
          this.setDay(this.today);
        } else {
          // Si estamos fuera de fechas del evento vamos a seleccionar el primer dia de pruebas
          this.setDay(this.show.dias[0]);
        }
        sessionStorage.setItem('showName', this.show.nombre);
        sessionStorage.setItem('showId', this.showId);
      }
    )
  }

  public getAnnouncements() {
    this.db.collection('concursos').doc(this.showId).collection('avisos', ref => ref.orderBy('created', 'desc')).valueChanges().subscribe(
      announcements => {
        this.announcements = announcements;
      }
    )
  }

  private getCompetitions() {
    this.db.collection('concursos').doc(this.showId).collection('pruebas', ref => ref.orderBy('orden')).valueChanges().subscribe(
      competitions => {
        this.competitions = competitions;
      }
    );
  }

  public getFilteredCompetitions() {
    return this.competitions.filter((competition) => {
      return competition.dia == this.day;
    });
  }

  public addToCalendar(competition: any) {
    if (!competition.inicio) {
      return;
    }

    const event = {
      title: `${competition.numero} - ${competition.nombre}`,
      description: `${competition.clave_modalidad} - ${competition.nombre_modalidad}\n${this.show.nombre}\n${this.show.lugar}`,
      location: this.show.lugar,
      startTime: competition.inicio.toDate(),
      endTime: new Date(competition.inicio.toDate().getTime() + (2 * 60 * 60 * 1000)), // 2 hours duration
      url: window.location.origin + `/competition/${this.showId}/${competition.ipc}`
    };

    // Generate calendar links
    const googleCalendarUrl = this.generateGoogleCalendarUrl(event);
    const outlookUrl = this.generateOutlookUrl(event);
    const icsUrl = this.generateICSFile(event);

    // Create a dropdown or modal with calendar options
    this.showCalendarOptions(event, googleCalendarUrl, outlookUrl, icsUrl);
  }

  private generateGoogleCalendarUrl(event: any): string {
    const params = new URLSearchParams({
      action: 'TEMPLATE',
      text: event.title,
      dates: `${this.formatDateForCalendar(event.startTime)}/${this.formatDateForCalendar(event.endTime)}`,
      details: event.description,
      location: event.location,
      ctz: Intl.DateTimeFormat().resolvedOptions().timeZone
    });
    return `https://calendar.google.com/calendar/render?${params.toString()}`;
  }

  private generateOutlookUrl(event: any): string {
    const params = new URLSearchParams({
      path: '/calendar/action/compose',
      rru: 'addevent',
      subject: event.title,
      startdt: this.formatDateForCalendar(event.startTime),
      enddt: this.formatDateForCalendar(event.endTime),
      body: event.description,
      location: event.location
    });
    return `https://outlook.live.com/calendar/0/deeplink/compose?${params.toString()}`;
  }

  private generateICSFile(event: any): string {
    const icsContent = [
      'BEGIN:VCALENDAR',
      'VERSION:2.0',
      'PRODID:-//Equestrian Digital//Calendar Event//EN',
      'BEGIN:VEVENT',
      `UID:${event.startTime.getTime()}@equestrian.digital`,
      `DTSTAMP:${this.formatDateForCalendar(new Date())}`,
      `DTSTART:${this.formatDateForCalendar(event.startTime)}`,
      `DTEND:${this.formatDateForCalendar(event.endTime)}`,
      `SUMMARY:${event.title}`,
      `DESCRIPTION:${event.description.replace(/\n/g, '\\n')}`,
      `LOCATION:${event.location}`,
      `URL:${event.url}`,
      'END:VEVENT',
      'END:VCALENDAR'
    ].join('\r\n');

    const blob = new Blob([icsContent], { type: 'text/calendar' });
    return URL.createObjectURL(blob);
  }

  private formatDateForCalendar(date: Date): string {
    return date.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
  }

  private showCalendarOptions(event: any, googleUrl: string, outlookUrl: string, icsUrl: string) {
    // Create a simple dropdown or use a modal
    const options = [
      { name: 'Google Calendar', url: googleUrl, icon: 'mdi mdi-google' },
      { name: 'Outlook', url: outlookUrl, icon: 'mdi mdi-microsoft' },
      { name: 'Download ICS', url: icsUrl, icon: 'mdi mdi-download', download: true }
    ];

    // For simplicity, we'll open Google Calendar by default
    // You could implement a proper dropdown/modal here
    window.open(googleUrl, '_blank');
  }
}

